<template>
  <v-container>
    <v-row class="text-center">
      <v-col class="mb-5" cols="12">
        <Crud v-bind:headers="headers" v-bind:moduleName="moduleName">
          <template v-slot:edit_content>
            <PurchaseForm></PurchaseForm>
          </template>
        </Crud>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Crud from "@/components/Crud";
import PurchaseForm from "@/components/PurchaseForm";

export default {
  components: {
    Crud: Crud,
    PurchaseForm: PurchaseForm,
  },

  computed: {
    editedItem: function () {
      return this.$store.getters.dataEdit(this.moduleName);
    },
  },

  data() {
    return {
      moduleName: "purchases",
      headers: [
        {
          title: this.$t("purchases.lines"),
          key: "lines",
          sortable: false,
        },
        { title: this.$t("purchases.ordered_at"), key: "ordered_at" },
        { title: this.$t("purchases.comment"), key: "comment" },
        { title: this.$t("purchases.quoted_at"), key: "quoted_at" },
        { title: this.$t("purchases.paid_at"), key: "paid_at" },
        { title: this.$t("purchases.sent_at"), key: "sent_at" },
        { title: this.$t("purchases.received_at"), key: "received_at" },
        {
          title: this.$t("actions.label"),
          key: "actions",
          sortable: false,
        },
      ],
      autocompleteSearch: null,
    };
  },
};
</script>
